import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import classnames from 'classnames';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import { getLanguageNameFromCode } from '../../../common/utils/languages';
import { validateKeyWithNoSpace, validateValue } from '../../../common/utils/validate';
import { LocalizationModel } from './LocalizationModel';
import { toast } from 'react-toastify';

export const LocalizationForm = ({
  projectId,
  setLanguage,
  language,
  localization,
  addLocalizationKeyValue,
  setToggleActiveLang,
  isReadOnly,
}) => {
  if (!(localization && localization.length > 0)) return '';
  const localizationSchema = {
    key: '',
    value: '',
  };
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    handleLanguageChange(language);
  }, [localization]);

  const handleLanguageChange = (tab) => {
    if (language !== tab) setLanguage(tab);
  };

  const handleSubmit = (values) => {
    const { key, value } = values;
    let isDuplicateKey = false;
    localization.forEach((local) => {
      local.languageKeyValues.forEach((languageKeyValue) => {
        if (languageKeyValue.key === key) isDuplicateKey = true;
      });
    });
    if (!isDuplicateKey) {
      addLocalizationKeyValue({ key, value, projectId }).then(() => handleLanguageChange(language));
    } else {
      toast.error('Key Already Exist');
    }
  };
  const showKeyFormModel = () => {
    return (
      <LocalizationModel title={'Add Key'} toggle={toggle} setToggle={setToggle}>
        <Formik
          initialValues={localizationSchema}
          onSubmit={!isReadOnly ? handleSubmit : undefined}
        >
          <Form className="form-horizontal">
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <CustomInputWithIcon icon="text" required={true}>
                  <Field
                    type="text"
                    name="key"
                    className="form-control form-control-sm"
                    placeholder="Key"
                    validate={validateKeyWithNoSpace}
                  />
                  <ErrorMessage name="key">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </CustomInputWithIcon>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <CustomInputWithIcon icon="text" required={true}>
                  <Field
                    type="text"
                    name="value"
                    className="form-control form-control-sm"
                    placeholder="Value"
                    validate={validateValue}
                  />
                  <ErrorMessage name="value">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </CustomInputWithIcon>
              </div>
              <div className="col-md-12 col-lg-12 mt-2 text-right">
                <button
                  className="btn btn-theme-submit btn-md"
                  type="submit"
                  disabled={isReadOnly}
                  title={isReadOnly && 'Read-Only Mode'}
                >
                  <i className={`wb ${drapcodeIcon('add')}`}></i>&nbsp;Add Key&nbsp;
                </button>
              </div>
            </div>
          </Form>
        </Formik>
      </LocalizationModel>
    );
  };
  return (
    <>
      {showKeyFormModel()}
      <Nav pills className="nav-pills-primary drapcode-nav-pills">
        {localization.map((lang, index) => (
          <NavItem key={index}>
            <NavLink
              className={classnames({ active: language === lang.language })}
              onClick={() => {
                handleLanguageChange(lang.language);
              }}
            >
              {getLanguageNameFromCode(lang.language)}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <form className="form-horizontal">
        <div className="row mx-auto">
          <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4"></div>
          <div className="col-md-8 col-lg-8 mt-2 text-right ">
            <div className="" style={{ position: 'relative', bottom: '140px' }}>
              <button
                className="btn btn-theme-submit btn-md"
                onClick={(e) => {
                  e.preventDefault();
                  setToggleActiveLang(true);
                }}
              >
                <i className={`wb ${drapcodeIcon('setup')}`}></i>&nbsp;Manage Language&nbsp;
              </button>
              &nbsp;
              <button
                className="btn btn-theme-submit btn-md"
                onClick={
                  isReadOnly
                    ? undefined
                    : (e) => {
                        e.preventDefault();
                        setToggle(true);
                      }
                }
                disabled={isReadOnly}
                title={isReadOnly && 'Read-Only Mode'}
              >
                <i className={`wb ${drapcodeIcon('add')}`}></i>&nbsp;Add Key&nbsp;
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};
